<style lang="less" scoped>
.kyzxDetails {position: relative;width: 100%;display: flex;flex-direction: column;font-family: AlibabaPuHuiTi-Medium;}
.first {display: flex;flex-direction: column;width: 830px;margin-right: 20px;}
.details {text-align: left;}
.relatedInfo {margin-top: 30px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 20px;color: rgb(25, 159, 248);}
</style>

<template>
  <div class="kyzxDetails">
    <div class="first">
<!--      <Navigation v-if="this.isMobile()" :navigationdatas="navigationListApp" class="navigation"></Navigation>-->
      <Navigation :navigationdatas="navigationList" class="navigation"></Navigation>
      <h1 style="display:none"> {{this.$route.query.id}} </h1>
      <Details class="details"></Details>
      <RelatedInfo class="relatedInfo" :relatedInfoList="relatedInfoListdata" @clickReInfo="goDetails">
        <span slot="icon"><i class="iconfont icon-xiangguan" /></span>
        <span slot="type">相关资讯 / Related Information</span>
        <span slot="description">换一换</span>
      </RelatedInfo>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 矿业资讯详情页面
 * 安进2021.06.22数据库接数据
 */
import Navigation from '../assembly/Navigation.vue'
import Details from '../assembly/Details.vue'
import RelatedInfo from '../assembly/RelatedInfo.vue'
import arrayFun from '../method/array.js'
export default {
  components: {
    Navigation,
    Details,
    RelatedInfo
  },
  name: '',
  data()
  {
    return {
      curID: null,
      // Navigation组件参数
      navigationList: [
        {theme: '首页', path: '/Kyforum'},
        {theme: '矿业资讯', path: '/KyzxIndex'},
        {theme: '', path: ''},
        {theme: '正文', path: '/'}
      ],
      navigationListApp: [
        {theme: '首页', path: '/KyforumApp'},
        {theme: '矿业资讯', path: '/KyzxIndex'},
        {theme: '', path: ''},
        {theme: '正文', path: '/'}
      ],
      relatedInfoListdata: [] // RelatedInfo组件参数
    }
  },
  created()
  {
    this.getXGZX()
  },
  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        this.getNAV(+nval.query.id)
      },
      immediate: true
    }
  },
  methods: {
    getNAV(num) //根据id去找分类名
    {
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id=?', types: 'i', vals: num}
      window.post.getPost(paras).then((ret) =>
      {
        switch (ret[0].catid)
        {
        case 5:
          this.navigationList[2].theme = '重要公告'
          this.navigationList[2].path = `/KyzxList?catid=5&ssgj=`
          break
        case 6:
          this.navigationList[2].theme = '勘查开发'
          this.navigationList[2].path = `/KyzxList?catid=6&ssgj=`
          break
        case 7:
          this.navigationList[2].theme = '投资贸易'
          this.navigationList[2].path = `/KyzxList?catid=7&ssgj=`
          break
        case 8:
          this.navigationList[2].theme = '政策风向'
          this.navigationList[2].path = `/KyzxList?catid=8&ssgj=`
          break
        case 9:
          this.navigationList[2].theme = '综合资讯'
          this.navigationList[2].path = `/KyzxList?catid=9&ssgj=`
          break
        }
      })
    },
    // 从矿业资讯数据表获取相关资讯的数据
    getXGZX()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 1, _exp: 'addtime>0 and examine = 0', orderby: 'edittime DESC', init: 0, pageno: 1, pagesize: 30}
      window.post.getPost(paras).then((ret) =>
      {
        let temp = []
        ret[0].data.forEach(item =>
        {
          temp.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.title, time: item.edittime, catid: item.catid})
        })
        this.relatedInfoListdata = temp.sort(arrayFun.compareBtoS('time'))
      })
    },
    // 跳转到矿业资讯详情页面，并将被点击的新闻的id传递到详情页面
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/KyzxDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 用户设备的判断
    isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyzxDetails.vue